// import React from 'react';
// import { Link } from 'react-router-dom';

// const services = [
//   {
//     title: 'High-Rise Buildings',
//     image: '/images/Picture53.jpg',
//     description: 'We specialize in the construction of high-rise residential and commercial buildings with unmatched precision.',
//     link: '/services/high-rise-buildings'
//   },
//   {
//     title: 'Steel Structure Fabrication',
//     image: '/images/Picture18.jpg',
//     description: 'Fabrication and installation of steel structures for industrial and commercial use.',
//     link: '/services/steel-structures'
//   },

//   {
//     title: 'School Construction',
//     image: '/images/Picture8.jpg', // Replace with your school image path
//     description: 'Building modern, well-equipped educational facilities with attention to safety, design, and functionality.',
//     link: '/services/school-construction'
//   },
//   {
//     title: 'Residential Projects',
//     image: '/images/Picture19.png',
//     description: 'Designing and building customized residential complexes and villas.',
//     link: '/services/residential'
//   },
//   {
//     title: 'Mosque Construction',
//     image: '/images/Picture35.jpg',
//     description: 'Construction of beautifully designed mosques with traditional architecture and modern facilities.',
//     link: '/services/mosques'
//   },
  
// ];

// const OurServices = () => {
//   return (
//     <div className="py-16 bg-gray-50">
//       <div className="text-center mb-12">
//         <h2 className="text-4xl font-bold text-teal-700">Our Services</h2>
//         <p className="text-gray-600 mt-2 text-lg">
//           Explore our wide range of professional construction services
//         </p>
//       </div>

//       <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//         {services.map((service, index) => (
//           <div
//             key={index}
//             className="bg-white shadow-md rounded-xl overflow-hidden transition hover:shadow-lg"
//           >
//             <img
//               src={service.image}
//               alt={service.title}
//               className="w-full h-56"
//             />
//             <div className="p-6 text-left">
//               <h3 className="text-xl font-semibold text-teal-800">{service.title}</h3>
//               <p className="text-gray-600 mt-2">{service.description}</p>
//               <Link
//                 to={service.link}
//                 className="inline-block mt-4 text-teal-600 hover:text-teal-800 font-medium"
//               >
//                 Learn More →
//               </Link>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default OurServices;


  import React, { useEffect, useState } from 'react';
  import { ImGift } from 'react-icons/im';
  import { Link } from 'react-router-dom';
  import AOS from 'aos';
  import 'aos/dist/aos.css';



  const slides = [
    {
      img: '/images/Picture63.jpg',
      subtitle: 'We Build Luxury',
      title: 'Elegant Villas with Modern Architecture',
    },
    {
      img: '/images/Picture64.jpg',
      subtitle: 'Sky-High Excellence',
      title: 'High-Rise Buildings Crafted to Perfection',
    },
    {
      img: '/images/Picture65.jpg',
      subtitle: 'Trusted Construction Partner',
      title: 'Your Vision, Our Commitment to Build',
    },
  ];



  const services = [
    {
      title: 'Project Management',
      description:
        'From timelines to resources, our experienced managers ensure smooth, on-time project execution with strict quality control.',
      img: '/images/c-skill2.jpg',
    },
    {
      title: 'Civil & Structural Works',
      description:
        'We specialize in civil infrastructure, foundations, and structural excellence for long-lasting construction.',
      img: '/images/c-skill3.jpg',
    },
    {
      title: 'Mechanical & Electrical Expertise',
      description:
        'Integration of modern MEP systems is our strong suit — efficient, safe, and future-ready installations.',
      img: '/images/c-skill4.jpg',
    },
    {
      title: 'High-Rise Buildings',
      img: '/images/Picture53.jpg',
      description: 'We specialize in the construction of high-rise residential and commercial buildings with unmatched precision.',
      link: '/services/high-rise-buildings',
    },
    {
      title: 'Steel Structure Fabrication',
      img: '/images/Picture73.jpg',
      description: 'Fabrication and installation of steel structures for industrial and commercial use.',
      link: '/services/steel-structures',
    },
    {
      title: 'School Construction',
      img: '/images/Picture8.jpg',
      description: 'Building modern, well-equipped educational facilities with attention to safety, design, and functionality.',
      link: '/services/school-construction',
    },
    {
      title: 'Residential Projects',
      img: '/images/Picture72.jpg',
      description: 'Designing and building customized residential complexes and villas.',
      link: '/services/residential',
    },
    {
      title: 'Mosque Construction',
      img: '/images/Picture35.jpg',
      description: 'Construction of beautifully designed mosques with traditional architecture and modern facilities.',
      link: '/services/mosques',
    },
  ];

  const OurServices = () => {

    

    const [current, setCurrent] = useState(0);

    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false, // This ensures animations run more than once
      });
    }, []);
    
    useEffect(() => {
      AOS.refresh(); // This forces re-triggering animation on each slide change
    }, [current]);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
      }, 5000);
      return () => clearInterval(interval);
    }, []);

    const prevSlide = () => {
      setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const nextSlide = () => {
      setCurrent((prev) => (prev + 1) % slides.length);
    };

    return (
      <>
        {/* Hero Slider */}
        <div className="relative w-full h-[90vh] overflow-hidden">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              <img
                src={slide.img}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center text-white px-4">
                <p className="text-xl sm:text-2xl md:text-3xl font-light mb-2">
                  {slide.subtitle}
                </p>
                <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold">
                  {slide.title}
                </h1>
              </div>
            </div>
          ))}

          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
          >
            ‹
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 z-20"
          >
            ›
          </button>

          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
            {slides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-3 h-3 rounded-full ${
                  current === idx ? 'bg-white' : 'bg-white/50'
                }`}
              ></button>
            ))}
          </div>
        </div>
        <section className="bg-white dark:bg-gray-900 py-10 px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                data-aos="fade-up"
                data-aos-delay={index * 100}
                data-aos-duration="800"
              >
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-56 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 dark:text-white">
                    {service.title}
                  </h3>
                  <p className="mt-4 text-gray-600 dark:text-gray-300 text-sm">
                    {service.description}
                  </p>
                  <div className="mt-4">
                    <h4 className="text-blue-500 font-medium">PACIFIC BUILDERS (PVT) LTD</h4>
                    <p className="text-gray-500 dark:text-gray-400 text-sm">
                      Construction Company
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
        {/* Skills Section */}
        {/* <div className="py-16 bg-white text-gray-800">
        <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-teal-700">Our Services</h2>
            <p className="text-lg">We bring a unique set of capabilities to every construction project.</p>
            
          </div>
        
          <div className="w-[90%] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {skills.map((skill, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
              >
                <img src={skill.img} alt={skill.title} className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h3 className="text-xl font-semibold mb-2">{skill.title}</h3>
                  <p className="text-gray-600 text-sm">{skill.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Services Section */}
        {/* <div className="py-16 bg-gray-50">
        

          <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-xl overflow-hidden transition hover:shadow-lg"
              >
                <img src={service.image} alt={service.title} className="w-full h-56 object-cover" />
                <div className="p-6 text-left">
                  <h3 className="text-xl font-semibold text-teal-800">{service.title}</h3>
                  <p className="text-gray-600 mt-2">{service.description}</p>
                  <Link
                    to={service.link}
                    className="inline-block mt-4 text-teal-600 hover:text-teal-800 font-medium"
                  >
                    Learn More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </>
    );
  };

  export default OurServices;
